import React, { useState } from "react";
import ContextApi from "../../../HOC/ContextsAPI/ContextApi";
import Layout from "../../../HOC/layout/Layout";
import AddCustomers from "../../PageComponent/CustomersDetails/AddCustomer/AddCustomers";
import ViewCustomers from "../../PageComponent/CustomersDetails/ViewCustomers/ViewCustomers";
import SecondaryHeader from "../../UI/SecondaryHeader/SecondaryHeader";

function Customer() {
  const [showData, setShowData] = useState("View");

  return (
    <ContextApi>
      <Layout>
        <div>
          <SecondaryHeader
            setShowData={setShowData}
            showData={showData}
            // viewBtn="ViewCustomer"
            // SearchText={SearchText}
          />
          {<ViewCustomers />}
        </div>
      </Layout>
    </ContextApi>
  );
}

export default Customer;
